import { render, staticRenderFns } from "./Motive.vue?vue&type=template&id=0a793b04&"
import script from "./Motive.vue?vue&type=script&lang=js&"
export * from "./Motive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports